import React, { useState, useEffect } from 'react';

const SafeImage = ({ src, alt, className, errorMessage = 'Image indisponible', placeholderClass = '' }) => {
  const [hasError, setHasError] = useState(!src);

  useEffect(() => {
    setHasError(!src);
  }, [src]);

  if (!src || hasError) {
    return (
      <div className={`${className || ''} bg-gray-700 flex items-center justify-center`}>
        <span className="text-gray-300 text-sm md:text-base">{errorMessage}</span>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={() => setHasError(true)}
      onLoad={() => setHasError(false)}
    />
  );
};

export default SafeImage;
